import routes from 'router/routes';

import { getToken } from 'api/utils/tokenManagement';

import { isAuthenticatedSelector } from 'store/auth/selectors';

import { useSelector } from 'hooks';

import { ILogoProps } from './types';

import * as S from './styled';

const Logo = ({ withoutText, height, withLogo = true }: ILogoProps) => {
    const isAuthenticated = useSelector(isAuthenticatedSelector);
    const logoLink = isAuthenticated && getToken() ? routes.PRIVATE.MAIN.path : routes.PUBLIC.LOGIN.path;

    return (
        <S.LogoContainer to={logoLink} height={height}>
            {withLogo && <S.LogoImageSvg $maxWidth={27} />}
            {!withoutText && <S.LogoText $maxWidth={95} />}
        </S.LogoContainer>
    );
};

export default Logo;
